import * as userActions from '../user/actions';
import * as allFOIVActions from './actions';
import { CLEAN_PERSISTED_STORAGE } from '~redux_related/GENERAL/actions';

const initialState = {
    list: null,
    isFetching: false,
    isLoaded: false,
    error: '',
};

export const AllFOIVCategoriesReducer = (state = initialState, action) => {
    switch (action.type) {
        case allFOIVActions.SET_ALL_FOIV_CATEGORIES_FETCHING:
            return {
                ...initialState,
                isFetching: action.isFetching,
            };

        case allFOIVActions.SET_ALL_FOIV_CATEGORIES_ERROR:
            return {
                ...state,
                error: action.error,
                isFetching: false,
                isLoaded: true,
            };

        case allFOIVActions.SET_ALL_FOIV_CATEGORIES:
            return {
                list: action.list,
                isFetching: false,
                isLoaded: true,
                error: '',
            };

        case allFOIVActions.ABORT_ALL_FOIV_CATEGORIES_REQUEST:
            return initialState;

        case allFOIVActions.CLEAN_ALL_FOIV_CATEGORIES:
            return initialState;

        case userActions.LOGOUT:
            return initialState;

        case userActions.LOGIN:
            return initialState;

        case CLEAN_PERSISTED_STORAGE:
            return initialState;

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/redux_related/AllFOIVCategories/reducer.js